import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import cdn from 'src/helper/cdn'

export default class {
  @observable data = {
    uid: 0,
    userReqStatus: {
      remark: ""
    },
    MyAccountInfo: {
      wealthlv: 0,
    }
  }

  @action async RequestDuid(map) {
    let d = await http.post('/web/RequestDuid', map)
    this.UserHaveRequestDuidRecord(map.uid)
    return d
  }

  @action async UserHaveRequestDuidRecord(uid) {
    let d = await http.post('/web/UserHaveRequestDuidRecord', { "uid": uid })
    if (d.code == 0) {
      this.data.userReqStatus = d.res
    }
  }

  @action async setUid(uid) {
    this.data.uid = uid || 0
  }

  @action async MyAccountInfo() {
    let d = await http.post('/web/MyAccountInfo', {})
    this.data.MyAccountInfo = d.res
  }

  @action async RequestDuidPreCheck() {
    let d = await http.post('/web/RequestDuidPreCheck', {})
    return d
  }
}



// WEBPACK FOOTER //
// src/store/app/duid.js